import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  file: null,
  image: null,
};

const slice = createSlice({
  name: 'attachment',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // IMPORT FILE
    importFileSuccess(state, action) {
      state.isLoading = false;
      state.file = action.payload;
    },

    // UPLOAD IMAGE
    uploadImageSuccess(state, action) {
      state.isLoading = false;
      state.image = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {  } = slice.actions;

// ----------------------------------------------------------------------

export function importFile(model, file) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const body = new FormData();
      body.append('model', model);
      body.append('file', file, file.name);
      const response = await axios.post('/attachment/import', body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      dispatch(slice.actions.importFileSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function attachFile(file) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const body = new FormData();
      body.append('name', file.name);
      body.append('file', file, file.name);
      const response = await axios.post('/attachment/upload', body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      dispatch(slice.actions.importFileSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function uploadImage(image) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const body = new FormData();
      body.append('name', image.name);
      body.append('image', image, image.name);
      const response = await axios.post('/media/upload', body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      dispatch(slice.actions.uploadImageSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
